module.exports = __webpack_public_path__ + "img/course.c417ca90.png";